import { Controller } from "@hotwired/stimulus"

// Shows only the sections relevant to the currently-selected value of a
// <select> — e.g. on the Visual step, picking "Cover motion" hides the
// aesthetic-loop and lyric sections so each style shows only its own settings.
//
// Markup:
//   <div data-controller="style-sections">
//     <select data-style-sections-target="select" data-action="change->style-sections#update">…</select>
//     <div data-style-sections-target="section" data-style-sections-for="aesthetic_loop">…</div>
//     <div data-style-sections-target="section" data-style-sections-for="cover_motion lyric_snippet">…</div>
//   </div>
//
// Sections are only HIDDEN (not disabled) so their values survive a style
// switch — a creator can flip between styles without losing what they typed.
//
// An optional shared "variant" <select> is repopulated from the variantsValue
// map (style => [[value, label], …]) when the style changes, and hidden +
// disabled (so it doesn't submit) for styles that have no variants.
export default class extends Controller {
  static targets = ["select", "section", "variant", "variantWrap"]
  static values = { variants: Object }

  connect() {
    this.update()
  }

  update() {
    const value = this.selectTarget.value
    this.sectionTargets.forEach((section) => {
      const forValues = (section.dataset.styleSectionsFor || "").split(/\s+/).filter(Boolean)
      section.hidden = !forValues.includes(value)
    })
    this.updateVariants(value)
  }

  updateVariants(style) {
    if (!this.hasVariantTarget) return

    const options = (this.variantsValue && this.variantsValue[style]) || []
    const hasOptions = options.length > 0
    if (this.hasVariantWrapTarget) this.variantWrapTarget.hidden = !hasOptions
    this.variantTarget.disabled = !hasOptions
    if (!hasOptions) return

    const current = this.variantTarget.value
    this.variantTarget.innerHTML = ""
    let matched = false
    options.forEach(([value, label]) => {
      const option = document.createElement("option")
      option.value = value
      option.textContent = label
      if (value === current) {
        option.selected = true
        matched = true
      }
      this.variantTarget.appendChild(option)
    })
    if (!matched) this.variantTarget.selectedIndex = 0
  }
}
